import { useEffect } from "react";
import { ProjetoDimensionadoHibrido } from "src/components/projetos/dimensionados_hibrido";
import { EdicaoLayoutHibrido } from "src/components/projetos/edicao/layouts/EdicaoLayoutHibrido";
import { appStore } from "src/framework/store/AppStore";

const PAGE_TITLE = "Edição projeto dimensionado híbrido";

export const ProjetoDimensionadoHibridoEdicaoPage = () => {
  useEffect(() => {
    appStore.setPageTitle(PAGE_TITLE);
    return () => {
      appStore.setPageTitle("");
    }
  }, [])

  return (
    <EdicaoLayoutHibrido>
      <div className="container">
        <div className="row">
          <div className="X12">
            <ProjetoDimensionadoHibrido />
          </div>
        </div>
      </div>
    </EdicaoLayoutHibrido>
  );
};
